export const page404 = 'https://smooved.be/the-smooved-operator';
export const houseMatch404 = 'https://housematch.be/404';
export const defaultTitle = 'DEFAULT_META.TITLE';
